import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import Authors from "layouts/users";
import Clients from "layouts/clients";
import Tags from "layouts/tags";
import Courses from "layouts/courses";
import Lessons from "layouts/lessons";
import SignIn from "layouts/authentication/sign-in";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Tableau de bord",
    role: "USER",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Profil",
    role: "USER",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
  },
  {
    type: "collapse",
    name: "Auteurs",
    role: "ADMIN",
    key: "authors",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/authors",
    component: <Authors />,
  },
  {
    type: "collapse",
    name: "Clients",
    role: "ADMIN",
    key: "clients",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/clients",
    component: <Clients />,
  },
  {
    type: "collapse",
    name: "Catégories",
    role: "ADMIN",
    key: "tags",
    icon: <Icon fontSize="small">collections_bookmark</Icon>,
    route: "/tags",
    component: <Tags />,
  },
  {
    type: "collapse",
    name: "Cours",
    role: "ADMIN",
    key: "courses",
    icon: <Icon fontSize="small">library_books</Icon>,
    route: "/courses",
    component: <Courses />,
  },
  {
    type: "collapse",
    name: "Léçons",
    role: "USER",
    key: "lessons",
    icon: <Icon fontSize="small">menu_book</Icon>,
    route: "/lessons",
    component: <Lessons />,
  },
  {
    type: "nocollapse",
    name: "Sign In",
    role: "USER",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routes;
